import React from 'react'
import {Page, Splitter, SplitterContent} from 'react-onsenui'
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';

import {showAlertMessage} from "../../modules/alert";
import {showToastMessage} from "../../modules/toast";
import {showLoaderMessage, hideLoaderMessage} from "../../modules/loader";
import SideMenu from "../app/sideMenu";
import CommonComment from '../app/commonComment';
/*import DisqusBoard from "../schedule/module/disqusBoard";*/


class Inquiry extends React.Component {
    constructor(props) {
        super(props);
        firebase.firestore().settings({timestampsInSnapshots: true});
        //firebase.functions().useFunctionsEmulator('http://localhost:5000');
    }

    state = {
        openSideMenu: false,
        tab: 'inquiry',
        suggestion: {title: '', description: '', contact: ''}
    };


    componentDidMount() {
        if (this.props.userInfo.isSignedIn) {

        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.userInfo.isSignedIn && nextProps.userInfo.isSignedIn) {

        }
    }

    showSideMenu = (show) => {
        this.setState({openSideMenu: show});
    };

    fillInForm = (type, event) => {
        switch (type){
            case 'suggestionTitle':
                this.setState({suggestion: {...this.state.suggestion, title: event.target.value}});
                break;
            case 'suggestDescription':
                this.setState({suggestion: {...this.state.suggestion, description: event.target.value}});
                break;
            case 'suggestionContact':
                this.setState({suggestion: {...this.state.suggestion, contact: event.target.value}});
                break;
            default:
                console.error('NO TARGET');
        }
    };

    submitInquiry = () => {
        const title = this.state.suggestion.title;
        const contact = this.state.suggestion.contact;
        const description = this.state.suggestion.description;

        if(title.length === 0){
            this.props.showAlertMessage("제목이 없습니다.", "작성 오류");
            return;
        } else if(contact.length === 0){
            this.props.showAlertMessage("연락처가 없습니다.", "작성 오류");
            return;
        }else if(description.length === 0){
            this.props.showAlertMessage("내용이 없습니다.", "작성 오류");
            return;
        }

        this.props.showLoaderMessage("문의 및 제안을 작성중입니다.");

        let uid = this.props.userInfo.uid ? this.props.userInfo.uid : 0;
        const inquiryJson = {title: title, contact: contact, description: description, uid:uid, isAnonymous: this.props.userInfo.isAnonymous, date: new Date().valueOf()};
        firebase.firestore().collection('inquiry').add(inquiryJson).then(() => {
            try {
                this.props.showAlertMessage('문의 및 제안을 작성하였습니다. 확인 후 연락드리겠습니다.', "작성 성공");
                this.props.hideLoaderMessage();

                this.props.history.goBack();
            } catch (e) {console.error(e)}
        }).catch((error) => {
            console.error(error);
            this.props.showToastMessage('문의 및 제안 작성 과정에서 문제가 발생하였습니다.');
            this.props.hideLoaderMessage();
        });
    };

    render() {

        return (
            <Splitter>
                <SideMenu openSideMenu={this.state.openSideMenu} showSideMenu={this.showSideMenu}/>
                <SplitterContent>
                    <Page>
                        <div className="toolbar toolbar--transparent">
                            <div className="toolbar__left">
                                <span className="toolbar-button" onClick={() => this.props.history.goBack()}>
                                    <i className="ion-ios-arrow-left"/>
                                </span>
                                <span className="toolbar-button" onClick={() => this.props.history.push('/home')}>
                                    <i className="ion-ios-home"/>
                                </span>
                            </div>
                            <div className="toolbar__center">
                                문의 및 제안
                            </div>
                            <div className="toolbar__right">
                                <span className="toolbar-button" onClick={() => this.showSideMenu(true)}>
                                    <i className="ion-navicon" style={{fontSize: '28px'}}/>
                                </span>
                            </div>
                        </div>

                        <div className="segment segment--material inquiry-segment">
                            <div className="segment__item segment--material__item">
                                <input type="radio" className="segment__input segment--material__input" name="target-inquiry-segment" checked={this.state.tab === 'inquiry'} onChange={() => this.setState({tab: 'inquiry'})}/>
                                <div className="segment__button segment--material__button">문의</div>
                            </div>
                            <div className="segment__item segment--material__item">
                                <input type="radio" className="segment__input segment--material__input" name="target-inquiry-segment" checked={this.state.tab === 'suggestion'} onChange={() => this.setState({tab: 'suggestion'})}/>
                                <div className="segment__button segment--material__button">제안</div>
                            </div>
                        </div>

                        <div className="inquiry-wrapper" style={this.state.tab === 'inquiry' ? {} : {display:'none'}}>
                            <CommonComment DOC_ID={'INQUIRY'}/>
                            {/*<DisqusBoard url={'/inquiry'} identifier={'INQUIRY'} title={'문의'}/>*/}
                        </div>

                        <div className="inquiry-wrapper" style={this.state.tab === 'suggestion' ? {} : {display:'none'}}>
                            <div className="inquiry-input-wrapper">
                                <span>제목:</span> <input className="text-input text-input--material" placeholder="제목" type="text" value={this.state.suggestion.title} onChange={(e) => this.fillInForm('suggestionTitle', e)}/>
                            </div>
                            <div className="inquiry-input-wrapper">
                                <span>연락처:</span> <input className="text-input text-input--material" placeholder="연락처" type="text" value={this.state.suggestion.contact} onChange={(e) => this.fillInForm('suggestionContact', e)}/>
                            </div>
                            <textarea className="textarea textarea--transparent"
                                      placeholder="문의 또는 제안 내용을 작성해 주세요."
                                      value={this.state.suggestion.description}
                                      style={{height: window.innerHeight - 240 + 'px'}}
                                      onChange={(e) => this.fillInForm('suggestDescription', e)}>
                            </textarea>

                            <button className="button button--material inquiry-submit" onClick={this.submitInquiry}>작성하기</button>
                        </div>





                    </Page>
                </SplitterContent>
            </Splitter>
        )
    }
}

const mapStateToProps = ({user}) => ({
    userInfo: user.userInfo,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showLoaderMessage: message => dispatch(showLoaderMessage(message)),
    hideLoaderMessage: () => dispatch(hideLoaderMessage()),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Inquiry))